/**
 * Safely extracts the year (YYYY) from a date string or number.
 * Handles formats like YYYY-MM-DD or just YYYY.
 * Returns an empty string if the input is invalid or cannot be parsed.
 */
export function getYear(dateValue: string | number | null | undefined): string {
  if (dateValue === null || dateValue === undefined) return ''

  let yearStr = ''
  if (typeof dateValue === 'number') {
    yearStr = dateValue.toString()
  } else {
    // Extract the first part assuming YYYY-MM-DD or just YYYY
    yearStr = dateValue.split('-')[0] || ''
  }

  // Validate if it looks like a 4-digit year
  return /^[0-9]{4}$/.test(yearStr) ? yearStr : ''
}
